import cookies from "./lib/cookies";
import animadoAlAparecer from "./lib/animado-al-aparecer";
import formulario from "./lib/formulario";
require('../sass/app.scss');
var ajustaVw = function () {
    document.documentElement.style.setProperty('--vw', "".concat(document.documentElement.clientWidth, "px"));
};
var configuraActualizacionDeAltura = function () {
    var ultimoAltoCabecera = -1;
    var body = document.body, cabeceraPrincipal = document.querySelector('.cabeceraPrincipal'), logo = document.querySelector('.cabeceraPrincipal__logo'), actualizaCabecera = function () {
        var altura = cabeceraPrincipal.getBoundingClientRect().right;
        if (ultimoAltoCabecera !== altura) {
            body.style.setProperty('--alto-cabecera', "".concat(altura, "px"));
            ultimoAltoCabecera = altura;
        }
        var alturaLogo = logo.getBoundingClientRect().width;
        body.style.setProperty('--alto-logo', "".concat(alturaLogo, "px"));
        requestAnimationFrame(actualizaCabecera);
    };
    actualizaCabecera();
};
var dataLayer = window.dataLayer;
addEventListener('resize', ajustaVw);
addEventListener('load', ajustaVw);
ajustaVw();
configuraActualizacionDeAltura();
animadoAlAparecer('.animado');
formulario('form', {
    dataLayer: dataLayer,
    ocultarEtiquetas: true
});
if (dataLayer) {
    cookies(dataLayer, window.cookies);
}
